import { type FC } from 'react';
import { Toast } from 'dibs-toaster/exports/Toast.ts';
import { FormattedMessage } from 'dibs-react-intl';

type Props = {
    isToastVisible: boolean;
    onClose: () => void;
};

const PhotoLikeFeedbackToast: FC<Props> = ({ onClose, isToastVisible }) => {
    // Toast creates DOM element with isVisible=false
    if (isToastVisible) {
        return (
            <Toast
                onClose={onClose}
                position="bottomCenter"
                type="snackbar"
                showCloseButton={false}
                closeAfterTimeout
                isVisible
                zIndex="aboveOverlay"
            >
                <FormattedMessage
                    defaultMessage="Photo saved to your Favorites"
                    id="dip.photoLiking.photoLikeFeedbackToast.saved"
                />
            </Toast>
        );
    }
    return null;
};

export default PhotoLikeFeedbackToast;
